import React, { ReactChild, ReactNode } from 'react'
import { css, cx } from '@emotion/css'
import { CsHelpCircledIcon as HelpIcon } from '../icons'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { WithTooltip } from '../../design-system'
import { formLabelCss, panelTitleCss } from '../text'
import { FormattedMessage } from 'react-intl'

interface Props {
  readonly children: ReactChild
  readonly edited?: boolean
  readonly htmlFor?: string
  readonly required?: boolean
  readonly showRequiredIndicator?: boolean
  readonly renderHelpContent?: () => ReactNode
  readonly className?: string
}

export function Label({
  children,
  edited,
  htmlFor,
  renderHelpContent,
  required,
  className,
  showRequiredIndicator = true
}: Props) {
  return (
    <label
      htmlFor={htmlFor}
      className={cx(
        formLabelCss,
        css`
          display: flex;
          align-items: center;
          white-space: nowrap;
        `,
        className
      )}
    >
      {children}
      {required && showRequiredIndicator && (
        <span
          className={css`
            margin-left: 2px;
          `}
        >
          *
        </span>
      )}
      {renderHelpContent && (
        <WithTooltip renderTooltipContent={renderHelpContent} placement="right">
          {({ onMouseEnter, onMouseLeave }) => (
            <div
              data-testid="help-icon-container"
              className={css`
                margin-left: 5px;
                margin-top: -3px;
              `}
            >
              <HelpIcon
                color={theme.color.neutral50}
                height={16}
                width={16}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              />
            </div>
          )}
        </WithTooltip>
      )}
      {edited && (
        <FormattedMessage id="detail_fieldEdited">
          {(text) => (
            <div
              className={css`
                ${panelTitleCss};
                margin-left: auto;
              `}
            >
              {text}
            </div>
          )}
        </FormattedMessage>
      )}
    </label>
  )
}
